export const sfBenchmark: Record<string, number> = {
    // 'Community Engineer': 199000,
    'Backend Engineer': 236000,
    'Content Marketer': 165000,
    'Customer Success Manager': 192000,
    'Data Engineer': 236000,
    'Developer Advocate': 236000,
    'Front End Developer': 212000,
    'Full Stack Engineer': 236000,
    'Graphic Designer': 128400,
    'Design Lead': 236000,
    // 'Mobile Engineer': 200000,
    'Operations Manager': 156000,
    'Product Designer': 186000,
    'Product Manager': 213600,
    'Product Marketer': 195000,
    Recruiter: 173000,
    'Site Reliability Engineer': 236000,
    'Talent Partner': 173000,
    // 'Technical Writer': 150000,
    // 'Sales Engineer': 190000,
}
